export default __webpack_public_path__ + "static/media/Wave.b043e669.png";